export default "__VITE_ASSET__CYry6BTQ__"